import React from 'react';
import styled from 'styled-components';

function Footer() {
  return (
    <FooterContainer className='d-flex flex-row justify-content-around align-items-center pt-4'>
      <FooterLink href='/?codeSeq=906&do=search-id'>
        <FooterText className='font-weight-500 text-gray-500'>
          아이디 찾기
        </FooterText>
      </FooterLink>
      <FooterDivider />
      <FooterLink href='?codeSeq=906&do=search-pw'>
        <FooterText className='font-weight-500 text-gray-500'>
          비밀번호 재설정
        </FooterText>
      </FooterLink>
      <FooterDivider />
      <FooterLink href='common/MOBILE_N3/pages/register/'>
        <FooterText className='font-weight-500 text-gray-500'>
          회원가입
        </FooterText>
      </FooterLink>
    </FooterContainer>
  );
}

const FooterContainer = styled.section``;
const FooterLink = styled.a``;
const FooterText = styled.h3`
  font-size: 14px;
  cursor: pointer;
`;
const FooterDivider = styled.div`
  width: 1px;
  height: 16px;
  border: 1px solid #dddddd;
`;

export default Footer;
